import { Link } from "react-router-dom";

import { FaInstagram, FaLinkedin, FaFacebook } from "react-icons/fa";
import { MdEmail } from "react-icons/md";

const footer = () => {
  return (
    <footer className=" bg-[#0F7084] z-100 xl:py-0">
      <div className="flex flex-row xl:px-8 open-sans">
        <div className="container mx-auto px-2 text-left sm:w-auto xl:w-full h-full">
          <div className="mx-4 flex justify-items-center justify-evenly gap-y-2 xl:flex-row xl:items-start flex-col mobile:text-2xl">
            <div className="flex flex-col items-center self-center xl:items-start xl:self-auto">
              <div className="flex items-center sm:px-[15rem] xl:px-0 xl:gap-2 xl:flex-row mb-4 xl:pt-4"></div>
              <span className="">
                <p className="text-center xl:text-left text-base lg:text-2xl lg:w-1/2 text-white lg:mt-6 xl:mt-0 mb-2 font-semibold">
                  Nglarang no 37, Malangrejo, RT 5/RW 35, Wedomartani, Ngemplak,
                  Sleman
                </p>
              </span>
            </div>
            {/* kontak person */}
            <div className="flex flex-col gap-4 text-base xl:text-lg text-white xl:my-6 px-6">
              <p className="font-bold">Hubungi Kami</p>
              <div className="flex">
                <a
                  href="https://www.instagram.com/waste.and.wishes/"
                  rel="noreferrer"
                  target="_blank"
                  className="group flex items-center gap-2 w-fit transition-colors hover:text-yellow-500"
                >
                  <FaInstagram
                    className="transition-all group-hover:text-yellow-500"
                    size="1.5rem"
                  />
                  <p>waste.and.wishes.indonesia</p>
                </a>
              </div>

              <div className="flex">
                <a
                  href="https://www.linkedin.com/company/waste-wishes-indonesia/?originalSubdomain=id"
                  rel="noreferrer"
                  target="_blank"
                  className="group flex items-center gap-2 w-fit transition-colors hover:text-yellow-500"
                >
                  <FaLinkedin
                    className="transition-all group-hover:text-yellow-500"
                    size="1.5rem"
                  />
                  <p>waste.and.wishes.indonesia</p>
                </a>
              </div>

              <div className="flex">
                <a
                  href="mailto:waste.and.wishes@gmail.com"
                  rel="noreferrer"
                  target="_blank"
                  className="group flex items-center gap-2 w-fit transition-colors hover:text-yellow-500"
                >
                  <MdEmail
                    className="transition-all group-hover:text-yellow-500"
                    size="1.5rem"
                  />
                  <p>waste.and.wishes@gmail.com</p>
                </a>
              </div>

              {/* <div className="flex">
                <a
                  href="https://wa.me/6281228779089"
                  rel="noreferrer"
                  target="_blank"
                  className="group flex items-center gap-2 w-fit transition-colors hover:text-yellow-500"
                >
                  <FaFacebook
                    className="transition-all group-hover:text-yellow-500"
                    size="1.5rem"
                  />
                  <p>waste & wishes Indonesia</p>
                </a>
              </div> */}
            </div>
          </div>
        </div>
      </div>
      <p className="text-xs text-white bg-light-blue py-2 mt-3 xl:mt-0 text-center">
        &copy; Developed & Designed by Mufidus Sani
      </p>
    </footer>
  );
};

export default footer;
